<!--
 * @Author: 
 * @LastEditTime: 2022-07-26 17:09:41
 * @Description: 
-->
<template>
  <div class="circle-item">
    <img src="../images/yunxing.png" />
  </div>
</template>

<script>
export default {
  name: 'FaultLibrary',
}
</script>

<style lang="scss" scoped>

.circle-item {
  position: relative;
}
@import './specialStyle.scss';

</style>
